// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","631":"contact","824":"portfolio"}[chunkId] + "." + {"443":"ed36717f","631":"30690237","824":"f9d38c8b"}[chunkId] + ".css";
};